import { defaultColumns, defaultSort } from '../../components/docket/dockets/columns';

export default {
  state: {
    dockets: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'ascending',
    },
  },
  getters: {
    dockets: state => state.dockets,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setDockets(state, dockets) {
      state.dockets = dockets;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/docket-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'docket-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'docket-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const dockets = await axios.get('api/dockets' + (query || ''));
        dockets.data.forEach(docket => docket.extra_fields = JSON.parse(docket.extra_fields));
        commit('setDockets', dockets);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },

    async fetchAllWithoutPagination ({ commit }) {
      try {
        return await axios.get('api/dockets/all');
      } catch (e) {
      }
    },

    async fetch({ commit }, id) {
      let docket = await axios.get(`api/dockets/${id}`);
      docket.extra_fields = JSON.parse(docket.extra_fields);
      return docket;
    },
    async create({ commit }, payLoad) {
      return await axios.post('api/dockets', payLoad);
    },
    async update({ commit }, payLoad) {
      return await axios.put('api/dockets', payLoad);
    },

    async delete({ commit }, id) {
      await axios.delete('api/dockets/' + id);
    },
    async searchPartner({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/dockets/partners' + (queryString || ''));
      } catch (e) {
      }
    },

    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/docket-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'Dockets'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
